module.exports = __webpack_public_path__ + "static/media/baobabe-trees.e485bdd2.jpg";